import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faPaperPlane, faPencil, faChartLine } from '@fortawesome/pro-regular-svg-icons';
import cn from 'classnames';
import './ShopActionsPanel.scss';

import { setAnalyticsMode } from '../../../Actions/UIActions';
import { isAnalyticsMode } from '../../../Helpers/ui_helpers';
import { isShopper, isLoggedIn } from '../../../Helpers/user_helpers';
import { copyToClipboard } from '../../../Helpers/helpers';

import Tooltip from '../../General/Tooltip';

import Loader from '../../Loader/Loader';

const ShopActionsPanel = props => {
  const { ui, isSavingShopData, isFetchingAnalytics, isEditingShopData, user, isMyShop, activeRefinementObjects } = props;
  const { activeCurator, activeCuratorGroup } = activeRefinementObjects;
  const analyticsOn = isAnalyticsMode(ui);

  // Copy Behavior
  const [isCopying, setIsCopying] = React.useState(false);
  const copy = () => {
    window.__ADD_EVENT__('Shop - Clicked Share', {
      Curator: activeCurator?.name || 'None',
      'Curator Group': activeCuratorGroup?.title || 'None'
    });
    if (navigator?.share) {
      navigator
        .share({
          title: 'ShopMy',
          text: 'Check out this curated shopping experience!',
          url: window.location.href
        })
        .then(() => {
          window.__ADD_EVENT__('Shop - Shared', {
            Curator: activeCurator?.name || 'None',
            'Curator Group': activeCuratorGroup?.title || 'None'
          });
        })
        .catch(() => {
          window.__ADD_EVENT__('Shop - Share Panel Closed', {
            Curator: activeCurator?.name || 'None',
            'Curator Group': activeCuratorGroup?.title || 'None'
          });
        });
    } else {
      setIsCopying(true);
      copyToClipboard(window.location.href, true, 'Copied to clipboard');
      setTimeout(() => setIsCopying(false), 1000);
    }
  };

  const canEditShop = isMyShop || (activeCurator && window.__ADMIN_CONTROL_MODE__);

  const actions = [
    {
      // label: isCopying ? 'Copied' : 'Share',
      tooltipLabel: isCopying ? 'Copied' : 'Share',
      icon: isCopying ? faCheck : faPaperPlane,
      onClick: copy,
      isVisible: !isEditingShopData && isLoggedIn(user)
    },
    {
      tooltipLabel: isShopper(user) ? 'Edit Info' : 'Edit Info',
      icon: faPencil,
      onClick: props.startEditingShopData,
      isVisible: canEditShop && !isEditingShopData
    },
    {
      label: 'Cancel',
      onClick: () => props.doneEditingShopData(false),
      isVisible: isEditingShopData
    },
    {
      label: isSavingShopData ? 'Saving...' : 'Save',
      onClick: () => props.doneEditingShopData(true),
      isVisible: isEditingShopData,
      className: 'primary'
    },
    {
      // label: analyticsOn ? 'Hide Analytics' : 'Show Analytics',
      tooltipLabel: analyticsOn ? 'Hide Analytics' : 'Show Analytics',
      icon: faChartLine,
      isVisible: !isShopper(user) && props.isYourShop,
      onClick: () => props.setAnalyticsMode(!analyticsOn),
      isLoading: isFetchingAnalytics,
      className: { loading: isFetchingAnalytics, primary: analyticsOn }
    }
  ].filter(action => action.isVisible);

  if (!actions.length) return null;

  return (
    <div className='shop-actions-panel-container'>
      <div className='actions'>
        {actions.map((action, idx) => (
          <Tooltip key={idx + action.label + action.tooltipLabel} message={action.tooltipLabel}>
            <div onClick={action.onClick} className={cn('action', { 'icon-only': !action.label && !!action.icon }, action.className)}>
              {action.label}
              {action.isLoading && <Loader size={48} />}
              {action.icon && <FontAwesomeIcon icon={action.icon} />}
            </div>
          </Tooltip>
        ))}
      </div>
    </div>
  );
};

ShopActionsPanel.propTypes = {
  // From Inside
  user: PropTypes.object.isRequired,
  ui: PropTypes.object.isRequired,
  setAnalyticsMode: PropTypes.func.isRequired,

  // From Outside
  isSavingShopData: PropTypes.bool.isRequired,
  isEditingShopData: PropTypes.bool.isRequired,
  startEditingShopData: PropTypes.func.isRequired,
  doneEditingShopData: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  const { user, ui } = state;
  return { user, ui };
};
export default connect(mapStateToProps, {
  setAnalyticsMode
})(ShopActionsPanel);
